<template>
  <div
    class="strategy strategyanimation"
    :class="isCollapse ? 'collapse' : ''"
    :style="{
      backgroundImage:
        'url(' +
        (isCollapse
          ? weapons[currentTab].mobileBackgroundImage
          : weapons[currentTab].backgroundImage) +
        ')',
    }"
    @click="openLink(weapons[currentTab].href)"
    
  >
  
    <div v-if="isCollapse" class="placeholder"></div>
    <div class="strategy-tabs" :class="isCollapse ? 'tab-collapse' : ''">
      <div
        v-for="(weapon, i) in weapons"
        :key="weapon.text"
        @click.stop="changeTab(i)"
        class="weapon"
        :class="currentTab == i ? 'active' : ''"
      >
        <img :src="currentTab == i ? (isCollapse?weapon.activeMobile:weapon.activePc) : weapon.pc" />
      </div>
    </div>
  </div>
</template>

<script>
import { useScreenState } from "../../../store";
import browser from '../../../utils/browser';

export default {
  name: "Strategy",
  data() {
    return {
      screenState: useScreenState(),
      weapons: [
        {
          pc: require("../../../assets/images/img_strategy_jian.png"),
          activePc: require("../../../assets/images/img_select_jian.png"),
          activeMobile: require("../../../assets/images/img_mobile_select_jian.png"),
          backgroundImage: require("../../../assets/images/img_occupation_jian.png"),
          mobileBackgroundImage: require("../../../assets/images/img_mobile_occupation_jian.jpg"),
          mobile: "",
          href: "/",
          text: this.$router.lang.get("劍系"),
        },
        {
          pc: require("../../../assets/images/img_strategy_qiang.png"),
          activePc: require("../../../assets/images/img_select_qiang.png"),
          activeMobile: require("../../../assets/images/img_mobile_select_qiang.png"),
          backgroundImage: require("../../../assets/images/img_occupation_qiang.png"),
          mobileBackgroundImage: require("../../../assets/images/img_mobile_occupation_qiang.jpg"),
          mobile: "",
          href: "/",
          text: this.$router.lang.get("槍系"),
        },
        {
          pc: require("../../../assets/images/img_strategy_dao.png"),
          activePc: require("../../../assets/images/img_select_dao.png"),
          activeMobile: require("../../../assets/images/img_mobile_select_dao.png"),
          backgroundImage: require("../../../assets/images/img_occupation_dao.png"),
          mobileBackgroundImage: require("../../../assets/images/img_mobile_occupation_dao.jpg"),
          mobile: "",
          href: "/",
          text: this.$router.lang.get("刀系"),
        },
        {
          pc: require("../../../assets/images/img_strategy_gong.png"),
          activePc: require("../../../assets/images/img_select_gong.png"),
          activeMobile: require("../../../assets/images/img_mobile_select_gong.png"),
          backgroundImage: require("../../../assets/images/img_occupation_gong.png"),
          mobileBackgroundImage: require("../../../assets/images/img_mobile_occupation_gong.jpg"),
          mobile: "",
          href: "/",
          text: this.$router.lang.get("弓系"),
        },
        {
          pc: require("../../../assets/images/img_strategy_quan.png"),
          activePc: require("../../../assets/images/img_select_quan.png"),
          activeMobile: require("../../../assets/images/img_mobile_select_quan.png"),
          backgroundImage: require("../../../assets/images/img_occupation_quan.png"),
          mobileBackgroundImage: require("../../../assets/images/img_mobile_occupation_quan.jpg"),
          mobile: "",
          href: "/",
          text: this.$router.lang.get("拳系"),
        },
        {
          pc: require("../../../assets/images/img_strategy_an.png"),
          activePc: require("../../../assets/images/img_select_an.png"),
          activeMobile: require("../../../assets/images/img_mobile_select_an.png"),
          backgroundImage: require("../../../assets/images/img_occupation_an.png"),
          mobileBackgroundImage: require("../../../assets/images/img_mobile_occupation_an.jpg"),
          mobile: "",
          href: "/",
          text: this.$router.lang.get("暗器"),
        },
      ],
      currentTab: 0,
      isChange:false
    };
  },
  computed: {
    isCollapse() {
      return this.screenState.screenWidth < 900;
    },
  },
  methods: {
    changeTab(i) {
      this.currentTab = i;
    },
    openLink(url) {
      if (browser.isPc)
          window.open(url)
      else
          this.$router.push(url)
    },
  },
};
</script>

<style scoped>
@keyframes move {
    0%{
        background-position: 0 -20px;
    }
    100%{
        background-position: -30px -20px;
    }
}

.strategy {
  height: calc(900 / 1920 * 100vw);
  /* max-width: calc(72vw + 200px); */
  margin: 0 auto;
  width: 100vw;
  cursor: pointer;
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-position: center center;
  
}
.strategyanimation{
  animation: move 2s alternate infinite;
}

.collapse {
  height: inherit;
  background-size: 100% auto;
  height: 167.8vw;
  background-position: 0 0;
}

.strategy-tabs {
  /* font-size: 1.2vw;
  font-weight: normal;
  color: #9f9399; */
  padding: 9vw 0 0 18vw;
}

.collapse .strategy-tabs {
  padding: 1vw;
}

.placeholder {
  height: calc(177.8vw - 120px);
}

.collapse .placeholder {
  height: 150.8vw;
}


.tab-collapse {
  display: flex;
  margin: 0 auto;
}

.weapon {
  padding-left: 0.4vw;
  height: 2vw;
  /* width: 5vw; */
  /* line-height: 20vw; */
  /* text-align: center; */
  margin-bottom: 3.5vw;
  cursor: pointer;
}

.weapon img {
  height: calc(79 / 1920 * 100vw);
  /* width: calc(79 / 1920 * 100vw); */
}

.collapse .weapon img {
  height: 13vw;
  width: 13vw;
}

.active {
  padding-left: 0;
}

.collapse .active img {
  height: 15.8889vw;
  width: 13vw;
  margin-top: -1.85vw;
}

.tab-collapse > .weapon {
  height: 16vw;
  width: 79px;
  text-align: center;
  margin: auto auto;
  /* background-image: url(""); */
  cursor: pointer;
}
</style>
